import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'

type NotNeededContentProps = {
  record: any
  recordDetails?: any
}

const NotNeededContent = ({ record, recordDetails }: NotNeededContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const comment = recordDetails?.comment || ''

  return (
    <>
      {comment && (
        <InfoRow>
          <Label>{t('COMMENT')}</Label>
          <Value>{comment}</Value>
        </InfoRow>
      )}
    </>
  )
}

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`


const Label = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  font-weight: 500;
`

const Value = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-weight: 400;
`

export default NotNeededContent
